module.exports = __webpack_public_path__ + "img/six.bff5b6c3.jpg";